import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UsersState {
    currentUserId: string | null;
}

const initialState: UsersState = {
    currentUserId: null,
};

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setCurrentUserId: (state, action: PayloadAction<string>) => {
            state.currentUserId = action.payload;
        },
        clearCurrentUserId: (state) => {
            state.currentUserId = null;
        },
    },
});

export const { setCurrentUserId, clearCurrentUserId } = usersSlice.actions;

// Selectors
export const selectCurrentUserId = (state: { users: UsersState }) => state.users.currentUserId;

export default usersSlice.reducer;
